import { Link as RouterLink } from 'react-router-dom';
import { Link as ScrollLink } from 'react-scroll';
import LanguageToggleButton from '../Common/LanguageToggleButton';
import { FaPhone, FaWhatsapp, FaEnvelope } from 'react-icons/fa';
import { FaXTwitter } from "react-icons/fa6";
import { BsInstagram, BsLinkedin } from 'react-icons/bs';
import SocialIcons from '../Common/SocialIcons';

const HeaderDesktop = ({
  isScrolled,
  site_info,
  navigation,
  contact_info,
  social_media,
  handleLogoClick,
  handleNavigation,
  activeSection,
  isRTL,
  t,
  scrollConfig,
  handleSetActive,
  LinkContent
}) => {
  return (
    <div className="hidden lg:block">
      <div className={`header-top-bar ${isScrolled ? 'hidden-top' : 'visible-top'} ${!isScrolled ? 'text-white bg-transparent' : 'bg-[var(--secondary-color)]/90'}`}>
        <div className="flex justify-between items-center pad-0 ml-10 mr-10">
          <div className="flex gap-2 items-center sm:gap-4">
            <a href={`tel:${contact_info?.phone?.replace(/\s+/g, '')}`}
              title={t('common.callUs')}
              className={`flex items-center text-english text-xs sm:text-sm md:text-base ${!isScrolled ? 'text-white' : 'text-[var(--primary-color)]'}`}>
              <FaPhone className={`mr-2 text-xs sm:text-sm md:text-base`} />
              <span dir="ltr">{contact_info.phone}</span>
            </a>
            <a href={`mailto:${contact_info.email}`}
              title={t('common.emailUs')}
              className={`flex items-center text-xs sm:text-sm md:text-base ${!isScrolled ? 'text-white' : 'text-[var(--primary-color)]'}`}>
              <FaEnvelope className={`mr-2 text-xs sm:text-sm md:text-base`} />
              <span dir="ltr">{contact_info.email}</span>
            </a>
          </div>
          <div className="flex gap-4 items-center">
            <SocialIcons
              socialMedia={social_media}
              translationFunc={t}
              translationKeyPrefix="contact.social"
              variant="header"
              isScrolled={isScrolled}
            />
          </div>
        </div>
      </div>

      <div className="ml-10 mr-10">
        <div className="flex justify-between items-center">
          <RouterLink
            to="/"
            onClick={handleLogoClick}
            className="text-2xl font-bold cursor-pointer"
            aria-label={site_info.site_name || "Home"}
          >
            <img src={site_info.logo} alt={site_info.title} className="h-20" />
          </RouterLink>

          <div className={`flex gap-1 items-center ${!isScrolled ? 'text-white' : 'text-[var(--primary-color)]'}`}>
            <ul className="flex gap-1 items-center sm:gap-1 md:gap-2 lg:gap-2 lx:gap-4">
              {navigation.map((item) => (
                <li key={item.id}>
                  {item.to ? (
                    <ScrollLink
                      to={item.to}
                      href={`/#${item.to}`}
                      {...scrollConfig}
                      onSetActive={() => handleSetActive(item.to)}
                      className={`flex items-center gap-1 sm:gap-1 md:gap-1 lg:gap-2 lx:gap-4 px-2 sm:px-4 py-1 sm:py-2 text-sm sm:text-base whitespace-nowrap transition-colors nav-link ${!isScrolled ? 'text-white hover:bg-[var(--primary-color)]' : 'text-[var(--primary-color)] hover:bg-[var(--primary-color)]'} ${isRTL ? 'text-arabic' : 'text-english'} ${activeSection === item.to ? 'nav-link-active' : ''}`}
                      onClick={() => handleNavigation(item)}
                    >
                      <LinkContent item={item} />
                    </ScrollLink>
                  ) : (
                    <RouterLink
                      to={item.href || '/'}
                      onClick={() => handleNavigation(item)}
                      className={`flex items-center gap-1 sm:gap-1 md:gap-1 lg:gap-2 lx:gap-4 px-2 sm:px-4 py-1 sm:py-2 text-sm sm:text-base whitespace-nowrap transition-colors nav-link ${!isScrolled ? 'text-white hover:bg-[var(--primary-color)]' : 'text-[var(--primary-color)] hover:bg-[var(--primary-color)]'} ${isRTL ? 'text-arabic' : 'text-english'} ${activeSection === item.href ? 'nav-link-active' : ''}`}
                    >
                      <LinkContent item={item} />
                    </RouterLink>
                  )}
                </li>
              ))}
            </ul>
            <LanguageToggleButton className="py-2" Location={false} isMobileView={true} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeaderDesktop;